<!-- eslint-disable vue/valid-v-on -->
<template>
  <Form @submit="() => {}">
    <div class="choose-label margin-bottom-xs margin-top-m medium">
      Choose your value:
    </div>
    <div>
      <div
        class="margin-bottom-s"
        :class="{'spacing-experiment': isSpacingExperimentEnabled }"
      >
        <SelectionTile
          v-model="values.giftCardAmount"
          name="giftCardAmount"
          :options="giftOptions"
          display-mode="stack"
        />
      </div>

      <template v-if="giftCardType !== GIFT_CARD_TYPE.CONSOLIDATED_MASTER">
        <div class="margin-bottom-s">
          <InputText
            v-model="values.giftCardAmount"
            name="giftCardAmount"
            label="Enter Custom Value*"
            type="text"
            rule="giftPrice"
          />
        </div>
        <div
          v-if="giftCardType === GIFT_CARD_TYPE.E_GIFT_CARD"
          class="margin-bottom-s"
        >
          <InputText
            v-model="values.giftCardEmailId"
            name="giftCardEmailId"
            type="email"
            label="Recipient's Email Address*"
            rule="email"
          />
        </div>
        <div class="wrapper margin-top-m">
          <span class="choose-label medium">Your Message:</span>
          <span class="helper-text small">(Optional)</span>
        </div>
        <div class="margin-bottom-s">
          <InputText
            v-model="values.giftCardToName"
            name="giftCardToName"
            label="To"
            rule="giftToFrom"
          />
        </div>
        <div class="margin-bottom-s">
          <InputText
            v-model="values.giftCardFromName"
            name="giftCardFromName"
            label="From"
            rule="giftToFrom"
          />
        </div>
        <div class="margin-top-s">
          <InputText
            v-model="values.giftCardMessage"
            name="giftCardMessage"
            label="Message"
            rule="giftMessage"
          />
          <div class="helper-text small">
            Your gift message can contain up to 60 characters.
          </div>
        </div>
      </template>
    </div>
    <button
      ref="submitBtn"
      class="hide"
      type="submit"
    >
      Submit
    </button>
    <CTAButtons
      v-if="callToActionButtons"
      class="margin-bottom-m margin-top-m"
      :atb-gift-payload="giftPayload"
      :atb-gift-validator="giftValidator"
    />
  </Form>
</template>

<script setup>
/* eslint-disable import/extensions */
import { ref } from 'vue';

import Form from '@atomic-ui/form';
import InputText from '@atomic-ui/inputText';
import SelectionTile from '@atomic-ui/selectionTile';

import { useExperiments } from '@composables/useExperiments';

import { useFeatureEligibility } from '@modules/featureControl';
import { UPC_VALIDATION_MESSAGES } from '@modules/upc';

import CTAButtons from './CTAButtons.vue';
import { useGiftCardForm, useGiftCardType, useGiftPayload } from '../composables';
import { GIFT_CARD_TYPE } from '../constants';

const { callToActionButtons } = useFeatureEligibility();

/**
 * @type {import('vue').Ref<HTMLButtonElement|null>}
 */
const submitBtn = ref(null);

const giftCardType = useGiftCardType();
const { values, validate, giftOptions } = useGiftCardForm(giftCardType);
const giftPayload = useGiftPayload(values, giftCardType);
const {
  experimentFlags: { isSpacingExperimentEnabled },
} = useExperiments();

const giftValidator = async () => {
  // vee-validate submitForm() doesn't work correctly.
  // It's not necessary to invest time to investigate if it's vee-validate issue itself or atomic ui one
  submitBtn.value.click();
  const result = await validate();
  if (result.errors.giftCardAmount === UPC_VALIDATION_MESSAGES.VALUE_NOT_SELECTED) {
    return result.errors.giftCardAmount;
  }
  return result.valid ? null : 'Invalid form';
};
</script>

<style lang="scss" scoped>
@import "~settingSCSS";
@import "~@core/csg/src/scss/forms/forms.scss";
@include csg-forms;

.choose-label {
  text-transform: uppercase;
}

.wrapper {
  display: flex;
  justify-content: space-between;
}

.spacing-experiment {
  :deep(.selection-tile) {
    height: 40px;
  }
}
</style>
